import axios from "axios";
import { apiBaseUrl } from "../utils/constants/env.constants";
import { PACKAGE_NAME } from "../utils/constants";
import { GLOBAL_APP_HEADERS } from "../utils/constants/GlobalAppAndLanguage";
import useZustandStore from "../zustandStore/useZustandStore";

export const axiosPublic = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
});

export const axiosPrivate = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
});

const addPackageNameInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      config.headers["package-name"] = PACKAGE_NAME;
      const { app, language } =
        useZustandStore.getState().globalAppAndLanguage || {};
      if (app && !config.headers[GLOBAL_APP_HEADERS.app])
        config.headers[GLOBAL_APP_HEADERS.app] = app;
      if (language && !config.headers[GLOBAL_APP_HEADERS.language])
        config.headers[GLOBAL_APP_HEADERS.language] = language;
      return config;
    },
    (error) => Promise.reject(error)
  );
};

addPackageNameInterceptor(axiosPublic);
addPackageNameInterceptor(axiosPrivate);
